var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZabkaMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 43,
    viewBox: "0 0 36 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.0613 0 0 7.6838 0 17.1648C0 26.6457 17.0534 42.9102 18 42.9102C18.9466 42.9102 36 26.6491 36 17.1665C36 7.6838 27.9387 0 18 0ZM18 24.0307C14.0238 24.0307 10.8 20.9564 10.8 17.1648C10.8 13.3731 14.0238 10.2989 18 10.2989C21.9762 10.2989 25.2 13.3731 25.2 17.1648C25.2 20.9564 21.9762 24.0307 18 24.0307Z",
    fill: "url(#paint0_linear_2145_110293)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2145_110293",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 42.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C42B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8C5D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZabkaMarker);
export default __webpack_public_path__ + "static/media/zabka-marker.3d03d439ae327eec5bcd4e85cb4479ed.svg";
export { ForwardRef as ReactComponent };